import Vue from "vue";
import Vuex from "vuex";

// import modules
import user from "./modules/user";
import usage from "./modules/usage";
import performance from "./modules/performance";
import datalink from "./modules/datalink";
import dashboard from "./modules/dashboard";
import coverage from "./modules/coverage";
import i18n from "./modules/i18n";
import filters from "./modules/filters";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user,
    usage,
    performance,
    datalink,
    dashboard,
    coverage,
    i18n,
    filters,
  },
});
